module.exports = __webpack_public_path__ + "img/agriculturalTop.9df20e70.jpg";